import { render } from "./StoryPage.vue?vue&type=template&id=6ee80319"
import script from "./StoryPage.vue?vue&type=script&lang=js"
export * from "./StoryPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/tai-g-damn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__